import { atom } from "recoil";

const workOrderValueAtom = atom({

    key:"workOrderValue",
    default: {
        serviceBundle: {data: [], note: ''},
        serviceList: {data: [], note: ''},
        materialList: {data: [], note: ''},
        otherList: {data: [], note: ''},
        technicianCost: '0',
        estimatedCompletionDate: '',
        estimatedCompletionTime: '',
        estimatedExpirationDate: '',
    }

});

export default workOrderValueAtom;